export default function Style(){
  return (
    <style>
      {`
       .pays_head{
    font-size: 22px;
    color: #1b1b1b;
    font-family: 'Josefin Sans';
}

.pays_para{
    color: #5e5e5e;
    font-family: 'Josefin Sans';
}
        `}
    </style>
  );
}
